import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OwnerAccountConnectedBankCard from "../../Accounts/OwnerAccount/OwnerAccountConnectedBankCard";
import Loader from "../../Loader/Index";

import { useNavigate } from "react-router-dom";
import { ownerAccountsViewAll } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import formatTotalBalance from "../../../utils/formatTotalBalance";
import PrimaryButton from "../CommonButtons/PrimaryButton";
import TickerAnimation from "../TickerAnimation";
import ICONS from "../../../assets/Icons";

const BalanceSummary = ({ type }) => {
  const [ownerAccounts, setOwnerAccounts] = useState([]);

  const [isBalanceSummaryOpen] = useState(true);
  const [connectedBankingTotal, setConnectedBankingTotal] = useState("");

  const [connectedDashboardDataLoading, setConnectedDashboardDataLoading] =
    useState(true);
  const [totalBalanceLoading, setTotalBalanceLoading] = useState(true);
  const [totalCountFav, setTotalCountFav] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [connectedBankingOwnerAccounts, setConnectedBankingOwnerAccounts] =
    useState([]);

  const [totalAccountsCount, setTotalAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const sessionResponse = JSON.parse(
    sessionStorage.getItem("response") || "{}",
  );
  const entityName = sessionResponse?.entity?.entity_name;
  const services = useSelector((state) => state.refreshToken.services);
  const requiredServices =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const refreshTokendata = useSelector((state) => state.refreshToken.data);
  const loginData = useSelector((state) => state.login.data);

  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  useEffect(() => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setConnectedBankingOwnerAccounts([]);
  }, [markerData]);

  useEffect(() => {
    const getAllConnectedBankingData = async () => {
      setTotalBalanceLoading(true);
      try {
        const response = await dispatch(
          ownerAccountsViewAll({
            page: GlobalConfiguration.lengthCheckOne,
            page_size: PaginationConfiguration.paginationSmall,
            connected_banking: "Y",
          }),
        );
        setOwnerAccounts(response?.payload?.owner_accounts || []);
        setConnectedBankingTotal(response?.payload?.total_balance || "");
        setTotalAccountsCount(
          response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
        );
      } catch (error) {
        console.error(error);
      } finally {
        setTotalBalanceLoading(false);
      }
    };

    getAllConnectedBankingData();
  }, [dispatch, markerData]);

  useEffect(() => {
    const getFavoriteConnectedBankingData = async () => {
      setConnectedDashboardDataLoading(true);

      try {
        const response = await dispatch(
          ownerAccountsViewAll({
            page: currentPage,
            page_size: PaginationConfiguration.paginationSmall,
            favourite: "Y",
          }),
        );

        const newData = response?.payload?.owner_accounts || [];
        setTotalCountFav(
          response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
        );

        setConnectedBankingOwnerAccounts(newData);
      } catch (error) {
        console.error(error);
      } finally {
        setConnectedDashboardDataLoading(false);
      }
    };

    getFavoriteConnectedBankingData();
  }, [dispatch, currentPage, markerData]);

  return (
    <div
      className={`flex flex-col w-ful lg:w-balance-summary-width h-balance-summary-height bg-primary-card rounded-border-radius-md overflow-hidden`}
    >
      <div className="flex gap-gap-sm items-center pt-padding-sm px-padding-md   flex-shrink-0">
        <img
          className="w-icon-sm h-icon-sm"
          src={ICONS?.ENTITIES_WHITE}
          alt="entity"
        />
        <p
          title={
            entityName ||
            refreshTokendata?.entity?.entity_name ||
            loginData?.entity?.entity_name
          }
          className="text-text-primary text-font-sm flex-1 truncate font-semibold"
        >
          <TickerAnimation
            text={
              entityName ||
              refreshTokendata?.entity?.entity_name ||
              loginData?.entity?.entity_name
            }
          />
        </p>
      </div>

      <div className="flex-1 min-h-height-base flex flex-col">
        {totalBalanceLoading || connectedDashboardDataLoading ? (
          <div className="flex-1 flex items-center justify-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className="pt-padding-sm px-padding-md pb-padding-sm flex flex-col gap-gap-xs flex-shrink-0">
              {requiredServices ? (
                <p className="text-font-xs font-normal text-text-primary">
                  <span
                    className={`text-font-sm ${
                      connectedBankingTotal
                        ? connectedBankingTotal <
                          GlobalConfiguration.lengthCheckZero
                          ? "text-failed font-semibold"
                          : "text-settled font-semibold"
                        : "text-text-primary font-normal"
                    }`}
                  >
                    {shouldBeRedacted(connectedBankingTotal) ? "" : "INR "}
                    {
                      formatTotalBalance(
                        connectedBankingTotal ||
                          GlobalConfiguration.lengthCheckZero,
                      ).amount
                    }{" "}
                    {formatTotalBalance(
                      connectedBankingTotal ||
                        GlobalConfiguration.lengthCheckZero,
                    ).prefix === ""
                      ? ""
                      : formatTotalBalance(
                          connectedBankingTotal ||
                            GlobalConfiguration.lengthCheckZero,
                        ).abbr}
                  </span>{" "}
                  in{" "}
                  <span className="text-font-sm font-semibold text-settled">
                    {totalAccountsCount}
                  </span>{" "}
                  accounts
                </p>
              ) : (
                <p className="text-font-sm text-settled font-semibold">
                  Redacted
                </p>
              )}
              <span className="text-text-primary font-normal text-font-xs">
                Total balance
              </span>
            </div>

            <div className="border-t border-primary-bg flex-shrink-0 mx-margin-md"></div>

            <div className="flex flex-col flex-1 min-h-height-base overflow-hidden pb-padding-sm">
              <div className="flex justify-between items-center px-padding-md py-padding-sm flex-shrink-0">
                <div className="flex gap-gap-sm items-center">
                  <img
                    className="w-icon-sm h-icon-sm"
                    src={ICONS?.FAVOURITE_FILLED}
                    alt="favourite"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    Favourites
                  </p>
                </div>
              </div>
              <div className="flex-1 min-h-height-base overflow-y-auto px-padding-md [@media(width:1024px)]:px-padding-sm">
                {connectedBankingOwnerAccounts.length >
                GlobalConfiguration.lengthCheckZero ? (
                  <div className="flex flex-col gap-gap-sm">
                    {connectedBankingOwnerAccounts.map((owner, index) => (
                      <div
                        key={owner.id}
                        className="flex flex-col justify-center"
                      >
                        <OwnerAccountConnectedBankCard
                          owner={owner}
                          ownerAccounts={ownerAccounts}
                          setOwnerAccounts={setOwnerAccounts}
                          ownerAccBalanceLoading={ownerAccBalanceLoading}
                          ownerAccBalanceError={ownerAccBalanceError}
                          updateTotalBalance={setConnectedBankingTotal}
                          total_balance={connectedBankingTotal}
                          isBalanceSummaryOpen={isBalanceSummaryOpen}
                          connectedBankingOwnerAccounts={
                            connectedBankingOwnerAccounts
                          }
                          setConnectedBankingOwnerAccounts={
                            setConnectedBankingOwnerAccounts
                          }
                        />

                        {index + GlobalConfiguration.lengthCheckOne ===
                          GlobalConfiguration.ownerAccountConnectedBankingLength && (
                          <p className="pt-padding-sm text-font-xxs text-white text-center">
                            Showing {connectedBankingOwnerAccounts.length} of{" "}
                            {totalCountFav} accounts
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex justify-center items-center h-full">
                    <p className="text-text-primary text-center text-font-xs font-normal">
                      Favourite owner accounts from their detail page.
                      <br />
                      Favourited owner accounts will appear here.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="border-t border-primary-bg flex-shrink-0 mx-margin-md"></div>

      <div className="pt-padding-sm px-padding-md pb-padding-sm flex-shrink-0">
        <PrimaryButton
          btnText="View all accounts"
          btnType="button"
          enabledBgColor="var(--primary-nav-act)"
          isDisabled={
            totalBalanceLoading ||
            connectedDashboardDataLoading ||
            (!services?.includes("VAccount") && !services?.includes("Admin"))
          }
          handleFunction={() => {
            if (totalBalanceLoading || connectedDashboardDataLoading) return;

            if (services?.includes("VAccount") || services?.includes("Admin")) {
              navigate("/owner_account_dashboard/owner_accounts_view_all");
            } else {
              navigate("/feature_not_assigned", {
                state: {
                  unavailableService: "VAccount, Admin",
                },
              });
            }
          }}
          iconToBeAlign="right"
          enabledTextColor="var(--text-primary)"
          icon={ICONS?.ARROW_RIGHT_WHITE}
          fullWidthRequired={true}
          isLoaderNeeded={false}
          hoverOption="white"
          imgColor="var(--text-primary)"
        />
      </div>
    </div>
  );
};

export default BalanceSummary;
